import {Alert} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {apiAuth, navigate, resetToTab} from 'services';
import {getUuid, Log, parseMultilanguage} from 'utils';
import CompChangeSuccess from './CompChangeSuccess';
import i18n from 'languages/i18n';

export const validateData = (p: Object, content?: string) => {
  let flag = true;
  Object.keys(p).map((item, index) => {
    if (!p?.[item]) {
      flag = false;
      Alert.showError({
        content: content || 'changecmnd.thongtinkhongduocdetrong',
      });
    }
  });
  return flag;
};

export const validateDate = (
  p: {
    date: any;
    fromdate: any;
    todate: any;
  },
  content: string,
) => {
  const dd = new Date(`${p.date.year}/${p.date.month}/${p.date.date}`);
  if (!validateData(p.date, content)) {
    return false;
  }
  if (dd < p.fromdate) {
    Alert.showError({
      content: content || 'changecmnd.thongtinkhongduocdetrong',
    });
    return false;
  }
  if (dd > p.todate) {
    Alert.showError({
      content: content || 'changecmnd.thongtinkhongduocdetrong',
    });
    return false;
  }
  return true;
};

export const convertchangeIdNoStatus = (status: string) => {
  switch (status) {
    case 'PENDING':
      return {
        title: parseMultilanguage(`changecmnd.${status}`),
        content: parseMultilanguage(`changecmnd.${status}_note`),
        icon: Icons.pending,
        color: Ecolors.yellowColor,
      };
    case 'REJECT':
      return {
        title: parseMultilanguage(`changecmnd.${status}`),
        content: parseMultilanguage(`changecmnd.${status}_note`),
        icon: Icons.reject,
        color: Ecolors.redColor,
      };
    default:
      return {
        title: parseMultilanguage(`changecmnd.${status}`),
        content: parseMultilanguage(`changecmnd.${status}_note`),
        icon: Icons.pending,
        color: Ecolors.yellowColor,
      };
  }
};

export const submitForm = async ({
  base64Uri,
  idNo,
  dateOfIssue,
  placeOfIssue,
  photoBeforeURL,
  photoAfterURL,
  expireDateOfIdNo,
}) => {
  try {
    if (
      validateData({
        base64Uri,
        idNo,
        dateOfIssue,
        placeOfIssue,
        photoBeforeURL,
        photoAfterURL,
      })
    ) {
      const id = getUuid();
      const formdata = new FormData();
      const blob = await fetch(base64Uri).then(res => res.blob());
      formdata.append('file', blob, `${id}.png`);
      formdata.append('idNo', idNo);
      formdata.append('dateOfIssue', dateOfIssue); // yyyyMMDD
      formdata.append('placeOfIssue', placeOfIssue);
      formdata.append('photoBeforeURL', photoBeforeURL);
      formdata.append('photoAfterURL', photoAfterURL);
      formdata.append('expireDateOfIdNo', expireDateOfIdNo); // yyyyMMDD
      const res = await apiAuth.changeIdNoCreate(formdata);
      if (res.status == 200) {
        navigate('OtpRequestModal', {
          data: {
            requestOnSendOtp: res.data?.otpInfo,
            flowApp: 'ChangeIDNo',
          },
          onConfirm: () => {
            return Alert.showComponent({
              component: () => (
                <CompChangeSuccess
                  content="changecmnd.PENDING_note"
                  onConfirm={() => {
                    resetToTab('ProfileScreen');
                  }}
                />
              ),
            });
          },
        });
        return;
      }
      Alert.showError({
        multilanguage: false,
        content: i18n.locale == 'vi' ? res.message : res.messageEn,
      });
    }
  } catch (error: any) {
    Log('error', error);
    Alert.showError({
      multilanguage: false,
      content: i18n.locale == 'vi' ? error.message : error.messageEn,
    });
  }
};
